import React from "react";
import {
  Box,
  Badge,
  AppBar,
  Toolbar,
  Backdrop,
  IconButton,
  CircularProgress
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SelectContract from "../SelectContract";
import {fetchLogOutUser} from "../../../../store/UserStore";
import { setContract } from "../../../../store/ContractsStore";
import { useNotification } from "../../../../contexts/NotificationContext";

const AppBarCustom = ({ title, sideBarWidth }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { clearNotifications } = useNotification();
  const [isBackdrop, setIsBackdrop] = React.useState(false);

  const contract = useSelector((state) => state.contracts?.contract || null);
  const notifications = useSelector((state) => state.notifications || { counts: {} });
  const handleChangeContract = React.useCallback((value) => {
    if (!value) return;
    dispatch(setContract(value));
  }, [dispatch]);

  const notificationsCount = React.useMemo(() => {
    const counts = notifications?.counts || {};
    return Object.values(counts).reduce((sum, count) => sum + (Number(count) || 0), 0);
  }, [notifications?.counts]);

  const handleLogOut = async () => {
    setIsBackdrop(true);
    await dispatch(fetchLogOutUser());
  };

  return (
    <>
      <AppBar position="fixed" className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <Link to="/" className={classes.logoLink}>
            <img src="/images/logo-full.svg" alt="Цифровой путь" height={32} />
          </Link>

          <Box className={classes.contractWrap} sx={{ left: sideBarWidth }}>
            <SelectContract statistic={contract} onChange={handleChangeContract} />
          </Box>

          <Box className={classes.rightBlock}>
            <Badge badgeContent={notificationsCount > 0 ? notificationsCount : null} color="primary">
              <IconButton
                className={classes.iconBtn}
                component={Link}
                to="/export"
                onClick={clearNotifications}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.925 10.3418L10.8333 11.3835V6.66683C10.8333 6.44582 10.7455 6.23385 10.5893 6.07757C10.433 5.92129 10.221 5.8335 10 5.8335C9.77899 5.8335 9.56703 5.92129 9.41075 6.07757C9.25447 6.23385 9.16667 6.44582 9.16667 6.66683V11.3252L8.09167 10.2418C7.93475 10.0849 7.72192 9.99675 7.5 9.99675C7.27808 9.99675 7.06525 10.0849 6.90833 10.2418C6.75141 10.3987 6.66326 10.6116 6.66326 10.8335C6.66326 11.0554 6.75141 11.2682 6.90833 11.4252L9.40833 13.9252C9.48759 14.001 9.58104 14.0605 9.68333 14.1002C9.78309 14.1443 9.89094 14.167 10 14.167C10.109 14.167 10.2169 14.1443 10.3167 14.1002C10.3657 14.0804 10.4108 14.0522 10.45 14.0168C10.4964 13.997 10.5388 13.9688 10.575 13.9335L13.075 11.5502C13.2352 11.3977 13.3283 11.1878 13.3338 10.9666C13.3392 10.7455 13.2566 10.5312 13.1041 10.371C12.9516 10.2108 12.7417 10.1177 12.5206 10.1122C12.2995 10.1067 12.0852 10.1893 11.925 10.3418Z" fill="currentColor"/>
                  <path d="M10 1.6665C8.35183 1.6665 6.74066 2.15525 5.37025 3.07092C3.99984 3.9866 2.93174 5.28809 2.30101 6.81081C1.67028 8.33353 1.50525 10.0091 1.8268 11.6256C2.14834 13.2421 2.94201 14.727 4.10745 15.8924C5.27289 17.0578 6.75774 17.8515 8.37425 18.173C9.99076 18.4946 11.6663 18.3296 13.189 17.6988C14.7118 17.0681 16.0132 16 16.9289 14.6296C17.8446 13.2592 18.3333 11.648 18.3333 9.99984C18.3333 8.90549 18.1178 7.82186 17.699 6.81081C17.2802 5.79976 16.6664 4.8811 15.8926 4.10728C15.1188 3.33346 14.2001 2.71963 13.189 2.30084C12.178 1.88205 11.0944 1.6665 10 1.6665ZM10 16.6665C8.68146 16.6665 7.39253 16.2755 6.2962 15.543C5.19988 14.8104 4.34539 13.7692 3.84081 12.5511C3.33622 11.3329 3.2042 9.99244 3.46144 8.69924C3.71867 7.40603 4.35361 6.21814 5.28596 5.28579C6.21831 4.35344 7.4062 3.7185 8.69941 3.46127C9.99261 3.20403 11.333 3.33606 12.5512 3.84064C13.7694 4.34522 14.8106 5.19971 15.5431 6.29604C16.2757 7.39236 16.6667 8.6813 16.6667 9.99984C16.6667 11.7679 15.9643 13.4636 14.714 14.7139C13.4638 15.9641 11.7681 16.6665 10 16.6665Z" fill="currentColor"/>
                </svg>
              </IconButton>
            </Badge>
            <IconButton className={classes.iconBtn} component={Link} to="/profile">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 9.16667C10.6593 9.16667 11.3037 8.97117 11.8519 8.6049C12.4 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2692 5.18303C13.1406 4.53643 12.8232 3.94249 12.357 3.47631C11.8908 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.33346 2.50144 8.72438 2.75374C8.11529 3.00603 7.5947 3.43327 7.22842 3.98143C6.86215 4.5296 6.66666 5.17406 6.66666 5.83334C6.66666 6.71739 7.01785 7.56524 7.64297 8.19036C8.26809 8.81548 9.11594 9.16667 10 9.16667ZM10 4.16667C10.3296 4.16667 10.6519 4.26442 10.9259 4.44755C11.2 4.63069 11.4136 4.89099 11.5398 5.19553C11.6659 5.50007 11.6989 5.83518 11.6346 6.15849C11.5703 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6484 7.40367 10.3251 7.46798C10.0018 7.53229 9.66673 7.49928 9.36219 7.37313C9.05764 7.24699 8.79734 7.03337 8.61421 6.75929C8.43107 6.4852 8.33332 6.16297 8.33332 5.83334C8.33332 5.39131 8.50892 4.96738 8.82148 4.65482C9.13404 4.34226 9.55797 4.16667 10 4.16667Z" fill="currentColor"/>
                <path d="M10 10.833C8.4529 10.833 6.96917 11.4476 5.87521 12.5416C4.78125 13.6355 4.16667 15.1192 4.16667 16.6663C4.16667 16.8874 4.25446 17.0993 4.41074 17.2556C4.56702 17.4119 4.77899 17.4997 5 17.4997C5.22101 17.4997 5.43297 17.4119 5.58926 17.2556C5.74554 17.0993 5.83333 16.8874 5.83333 16.6663C5.83333 15.5613 6.27232 14.5015 7.05372 13.7201C7.83512 12.9387 8.89493 12.4997 10 12.4997C11.105 12.4997 12.1649 12.9387 12.9463 13.7201C13.7277 14.5015 14.1667 15.5613 14.1667 16.6663C14.1667 16.8874 14.2545 17.0993 14.4107 17.2556C14.567 17.4119 14.779 17.4997 15 17.4997C15.221 17.4997 15.433 17.4119 15.5893 17.2556C15.7455 17.0993 15.8333 16.8874 15.8333 16.6663C15.8333 15.1192 15.2188 13.6355 14.1248 12.5416C13.0308 11.4476 11.5471 10.833 10 10.833Z" fill="currentColor"/>
              </svg>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Backdrop open={isBackdrop}>
        <CircularProgress />
      </Backdrop>
    </>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    height: 80,
    zIndex: 1000,
    background: "#FFFFFF !important",
    borderBottom: "1px solid #E4E4E7",
    boxShadow: "none !important",
  },
  toolbar: {
    height: "100% !important",
    minHeight: "80px !important",
    padding: "0 24px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  logoLink: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    textDecoration: "none",
    transition: "opacity 0.2s",
    "&:hover": {
      opacity: 0.8,
    },
  },

  contractWrap: {
    position: "absolute",
    top: 20,
    width: 340,
  },

  rightBlock: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
  },
  iconBtn: {
    width: 44,
    height: 44,
    borderRadius: 8,
    color: "#52525B",
    "&:hover": {
      backgroundColor: "#F4F4F5",
      color: "#4F39F6",
    },
  },
}));

export default AppBarCustom;
